import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    searchRecipients: builder.query({
      query: ({ query = "", role } = {}) => ({
        url: `admin/notification/search`,
        method: "GET",
        params: { query, role },
      }),
    }),
    sendNotification: builder.mutation({
      query: (body) => ({
        url: `admin/notification/send`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useLazySearchRecipientsQuery, useSendNotificationMutation } = notificationApi;
